export default __webpack_public_path__ + "static/media/store-4.66bed785.png";